// src/components/dashboard/stats/DifficultCardsToday.tsx
// ✅ REFATORADO COM PREFIXOS

import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';

interface DifficultCard {
    cardId: string;
    front: string;
    back: string;
    deckName: string;
    subdeckName: string;
    lastRating: number;
    consecutiveWrong: number;
    totalReviews: number;
}

interface DifficultCardsTodayProps {
    cards: DifficultCard[];
}

const DifficultCardsToday: React.FC<DifficultCardsTodayProps> = ({ cards }) => {
    const [selectedCard, setSelectedCard] = useState<DifficultCard | null>(null);

    if (cards.length === 0) {
        return null;
    }

    const stripHtml = (html: string): string => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || '';
    };

    return (
        <>
            <div className="dsb-estx-hj-difficult">
                <h3>
                    <AlertTriangle size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
                    Cards que Precisam de Atenção
                </h3>

                <div className="dsb-estx-hj-difficult-list">
                    {cards.map((card) => (
                        <div
                            key={card.cardId}
                            className="dsb-estx-hj-difficult-item"
                            onClick={() => setSelectedCard(card)}
                        >
                            <div className="dsb-estx-hj-difficult-front">
                                {stripHtml(card.front).substring(0, 100)}
                                {stripHtml(card.front).length > 100 ? '...' : ''}
                            </div>
                            <div className="dsb-estx-hj-difficult-meta">
                                <span>Nota {card.lastRating}/5</span>
                                {card.consecutiveWrong > 0 && (
                                    <span>• {card.consecutiveWrong} erro{card.consecutiveWrong > 1 ? 's' : ''} seguido{card.consecutiveWrong > 1 ? 's' : ''}</span>
                                )}
                                <span>• {card.deckName}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal de Detalhes */}
            {selectedCard && (
                <div className="dsb-estx-modal-overlay" onClick={() => setSelectedCard(null)}>
                    <div className="dsb-estx-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="dsb-estx-modal-header">
                            <h3>Detalhes do Card</h3>
                            <button
                                className="dsb-estx-modal-close"
                                onClick={() => setSelectedCard(null)}
                            >
                                ✕
                            </button>
                        </div>

                        <div className="dsb-estx-modal-body">
                            <div className="dsb-estx-modal-section">
                                <h4>Pergunta:</h4>
                                <div
                                    className="dsb-estx-modal-content"
                                    dangerouslySetInnerHTML={{ __html: selectedCard.front }}
                                />
                            </div>

                            <div className="dsb-estx-modal-section">
                                <h4>Resposta:</h4>
                                <div
                                    className="dsb-estx-modal-content"
                                    dangerouslySetInnerHTML={{ __html: selectedCard.back }}
                                />
                            </div>

                            <div className="dsb-estx-modal-stats">
                                <div className="dsb-estx-modal-stat">
                                    <span className="dsb-estx-modal-stat-label">Última nota:</span>
                                    <span className={`dsb-estx-modal-stat-value rating-${selectedCard.lastRating}`}>
                                        {selectedCard.lastRating}/5
                                    </span>
                                </div>
                                <div className="dsb-estx-modal-stat">
                                    <span className="dsb-estx-modal-stat-label">Erros consecutivos:</span>
                                    <span className="dsb-estx-modal-stat-value">{selectedCard.consecutiveWrong}</span>
                                </div>
                                <div className="dsb-estx-modal-stat">
                                    <span className="dsb-estx-modal-stat-label">Total de revisões:</span>
                                    <span className="dsb-estx-modal-stat-value">{selectedCard.totalReviews}</span>
                                </div>
                            </div>

                            <div className="dsb-estx-modal-meta">
                                <p><strong>Deck:</strong> {selectedCard.deckName}</p>
                                <p><strong>Subdeck:</strong> {selectedCard.subdeckName}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default DifficultCardsToday;